import { Select } from 'antd'
import React from 'react'

const SelectItem = ({ title, formData, setFormData, options, value }) => {
    return (
        <div className='form-item'>
            <label>{title}</label>
            <div className=''>
                <Select
                    className='w-100 mt--5 h40px'
                    options={options}
                    value={formData[value]}
                    onChange={(e) => setFormData({ ...formData, [value]: e })}
                />
            </div>
        </div>
    )
}

export default SelectItem
